<div class=" mt-4">
  <section>
      <div class="scrollmenu">
          <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
          <a [routerLink]="['/pos/customer/new']"> Customer </a>
          <a [routerLink]="['/pos/Employee/new']"> Employee </a>
          <a [routerLink]="['/pos/orders/new']"> Orders</a>
          <a [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
          <a [routerLink]="['/pos/category/new']"> Item-Category </a>
          <a [routerLink]="['/pos/item/new']"> Items </a>
          <a [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
          <!-- <a [routerLink]="['/pos/order/new']"> Order </a>
          <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
          <a [routerLink]="['/pos/payment/new']"> Payment </a>
          <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
          <a [routerLink]="['/pos/tip/new']"> Tips </a> -->

          <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
          <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
          <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
      </div>

  </section>
  <section class="mt-2">
      <div class="">
          <div class="row">
              <div class="col-md-12">
                  <div class="text-right py-2">
                    <button class="dash-btns btn" [routerLink]="['/pos/orderreceipt/manage']">Manage
                      Order Receipt</button>
                  </div>
              </div>
              <div class="col-md-7">
                  <div class="card-1">
                      <div class="row">
                          <div class="col-md-12">
                            
                              <div class="text-center">
                                  <!-- <a class="view-h gary-t mb-3">Order</a> -->
                                  <div class="col-md-12" *ngIf="isNewRecipt">
                                    <h4 class="font20 gary-t pt-3">Order Receipt</h4>
                                  </div>
                                  <div class="col-md-12" *ngIf="isUpdateRecipt">
                                    <h4 class="font20 gary-t pt-3">Lets Update a Order Type</h4>
                                  </div>
                                  


                              </div>

                              <div class="py-3">
                                <form #fnebusiness="ngForm">
                                  <div class="row mx-0">
                                    <!-- New Order starts -->
                                    <div class="col-md-12" *ngIf="isNewRecipt">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group">
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">Add No of BlankLine Top Of Receipt
                                                *</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Add No of BlankLine Top Of Receipt "
                                                  id="AddNoofBlankLineTopOfReceipt" name="AddNoofBlankLineTopOfReceipt"
                                                  [formControl]="AddNoofBlankLineTopOfReceipt" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="AddNoofBlankLineTopOfReceipt.invalid && (AddNoofBlankLineTopOfReceipt.dirty || AddNoofBlankLineTopOfReceipt.touched)">{{AddNoofBlankLineTopOfReceiptError()}}</span>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">Order Number RollOver After
                                                *</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Order NumberRollOverAfter" id="OrderNumberRollOverAfter"
                                                  name="OrderNumberRollOverAfter" [formControl]="OrderNumberRollOverAfter" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="OrderNumberRollOverAfter.invalid && (OrderNumberRollOverAfter.dirty || OrderNumberRollOverAfter.touched)">{{OrderNumberRollOverAfterError()}}
                                              </span>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">Order Number Type
                                                *</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Order Number Type" id="OrderNumberType"
                                                  name="OrderNumberType" [formControl]="OrderNumberType" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="OrderNumberType.invalid && (OrderNumberType.dirty || OrderNumberType.touched)">{{OrderNumberTypeError()}}
                                              </span>
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">UseLargeFond</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="UseLargeFond" id="UseLargeFond" name="UseLargeFond"
                                                  (click)="UseLargeFond1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">OrderNotes</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="OrderNotes" id="OrderNotes" name="OrderNotes"
                                                  (click)="OrderNotes1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">UserAlternativeInventoryName</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="UserAlternativeInventoryName"
                                                  id="UserAlternativeInventoryName" name="UserAlternativeInventoryName"
                                                  (click)="UserAlternativeInventoryName1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">GroupLineItems</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="GroupLineItems" id="GroupLineItems"
                                                  name="GroupLineItems" (click)="GroupLineItems1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">ShowModifierName</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="ShowModifierName" id="ShowModifierName"
                                                  name="ShowModifierName" (click)="ShowModifierName1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">GroupModifiers</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="GroupModifiers" id="GroupModifiers"
                                                  name="GroupModifiers" (click)="GroupModifiers1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">ShowCustomerInfo</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="ShowCustomerInfo" id="ShowCustomerInfo"
                                                  name="ShowCustomerInfo" (click)="ShowCustomerInfo1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">SmsReceipt</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="SmsReceipt" id="SmsReceipt" name="SmsReceipt"
                                                  (click)="SmsReceipt1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">EmailReceipt</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="EmailReceipt" id="EmailReceipt" name="EmailReceipt"
                                                  (click)="EmailReceipt1()" />
                                              </div>
                                            </div>
                                          </div>
                      
                                          <div class="text-right pt-3">
                      
                                            <button class="btn dash-btns"  id="btnSaveOrderReceipt"
                                              [disabled]="AddNoofBlankLineTopOfReceipt.invalid||OrderNumberRollOverAfter.invalid||OrderNumberType.invalid"
                                              (click)="newOrderReceipt()">Submit</button>
                                          </div>
                                        </div>
                      
                                      </form>
                                    </div>
                                    <!-- order Update starts -->
                                    <div class="col-md-12" *ngIf="isUpdateRecipt">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group">
                      
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">Add No of BlankLine Top Of Receipt
                                                *</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Add No of BlankLine Top Of Receipt "
                                                  [(ngModel)]="rows.addNoofBlankLineTopOfReceipt" id="AddNoofBlankLineTopOfReceipt"
                                                  name="AddNoofBlankLineTopOfReceipt" [formControl]="AddNoofBlankLineTopOfReceipt"
                                                  (keydown)="onKey()" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="AddNoofBlankLineTopOfReceipt.invalid && (AddNoofBlankLineTopOfReceipt.dirty || AddNoofBlankLineTopOfReceipt.touched)">{{AddNoofBlankLineTopOfReceiptError()}}</span>
                                            </div>
                                          </div>
                                          <input type="hidden" [(ngModel)]="rows.id" id="id" name="id" [formControl]="id">
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">Order Number RollOver After
                                                *</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Order NumberRollOverAfter" (keydown)="onKey()"
                                                  [(ngModel)]="rows.orderNumberRollOverAfter" id="OrderNumberRollOverAfter"
                                                  name="OrderNumberRollOverAfter" [formControl]="OrderNumberRollOverAfter" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="OrderNumberRollOverAfter.invalid && (OrderNumberRollOverAfter.dirty || OrderNumberRollOverAfter.touched)">{{OrderNumberRollOverAfterError()}}
                                              </span>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">Order Number Type
                                                *</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Order Number Type" (keydown)="onKey()"
                                                  [(ngModel)]="rows.orderNumberType" id="OrderNumberType" name="OrderNumberType"
                                                  [formControl]="OrderNumberType" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="OrderNumberType.invalid && (OrderNumberType.dirty || OrderNumberType.touched)">{{OrderNumberTypeError()}}
                                              </span>
                                            </div>
                                          </div>
                      
                      
                      
                      
                      
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">UseLargeFond</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <!-- <input type="checkbox" [(ngModel)]="UseLargeFond" id="UseLargeFond" name="UseLargeFond"  (click)="UseLargeFond1()"/> -->
                                                <input type="checkbox" [(ngModel)]="UseLargeFond" (click)="onKey()" id="UseLargeFond"
                                                  name="UseLargeFond" (click)="UseLargeFond1()">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">OrderNotes</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="OrderNotes" (click)="onKey()" id="OrderNotes"
                                                  name="OrderNotes" (click)="OrderNotes1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">UserAlternativeInventoryName</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="UserAlternativeInventoryName" (click)="onKey()"
                                                  id="UserAlternativeInventoryName" name="UserAlternativeInventoryName"
                                                  (click)="UserAlternativeInventoryName1()" />
                                              </div>
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">GroupLineItems</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="GroupLineItems" id="GroupLineItems" (click)="onKey()"
                                                  name="GroupLineItems" (click)="GroupLineItems1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">ShowModifierName</label>
                                            </div>
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="ShowModifierName" id="ShowModifierName" (click)="onKey()"
                                                  name="ShowModifierName" (click)="ShowModifierName1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">GroupModifiers</label>
                                            </div>
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="GroupModifiers" id="GroupModifiers" name="GroupModifiers"
                                                  (click)="onKey()" (click)="GroupModifiers1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">ShowCustomerInfo</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="ShowCustomerInfo" id="ShowCustomerInfo" (click)="onKey()"
                                                  name="ShowCustomerInfo" (click)="ShowCustomerInfo1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">SmsReceipt</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="SmsReceipt" id="SmsReceipt" name="SmsReceipt"
                                                  (click)="onKey()" (click)="SmsReceipt1()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                                            <div class="col-md-6 col-lg-5">
                                              <label for="sel1">EmailReceipt</label>
                                            </div>
                                             
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                                                <input type="checkbox" [(ngModel)]="EmailReceipt" id="EmailReceipt" name="EmailReceipt"
                                                  (click)="onKey()" (click)="EmailReceipt1()" />
                                              </div>
                                            </div>
                                          </div>
                      
                                          <input type="hidden" [(ngModel)]="rows.id" id="id" name="id" [formControl]="id">
                      
                                          <div class="text-right pt-3">
                                            <button class=" btn dash-btns mr-3"  [routerLink]="['/pos/orderreceipt/manage',{}]"
                                              matTooltip="go back to List">Cancel</button>
                      
                                            <button class="btn dash-btns"  id="btnupdateOrderReceipt"
                                              [disabled]="AddNoofBlankLineTopOfReceipt.invalid||OrderNumberRollOverAfter.invalid||OrderNumberType.invalid ||!isReadytoUpdaterecipt"
                                              (click)="updateOrderReceipt()">Update</button>
                                          </div>
                      
                                        </div>
                                      </form>
                      
                                    </div> 
                      
                      
                      
                                  </div>
                                </form>
 



                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-5">
                <div class="text-center mb-5">
                  <img src="assets/img/new/pos.svg" />
              </div>
              </div>
          </div>
      </div>
  </section>

</div>


<!-- 
<section >
  <div class="block-header">
    <div class="">
      <div class="row ">
        <div class="col-md-12  p-0">
          <h2 class="poppins font-weight-bold pl-2"> Order Receipt</h2>
        </div>
        <div class=" col-md-5 px-6 col-sm-12 p-0">

          <div class="breadcrumb flat">
            <a [routerLink]="['/pos']"> Home </a>
            <a href="#" class="active">Order Receipt</a>
          </div>
        </div>
        <div class="col-md-7">
          <div class="float-right">
            

          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-12 p-0">
        <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
          <div class="row mx-0">
          

          </div>
         
        </div>
      </div>
    </div>
  </div>
</section> -->